/**
 * フォームが変更されている場合に確認ダイアログを表示する
 * this.$refs.form.$refs.observer.flags.changedを監視する
 * 引数のformRefでフォームのrefを変更できる
 */
export default function confirmIfFormChanged(formRef = 'form') {
  return {
    data() {
      return {
        /**
       * こちらがtrueの場合は画面遷移時に確認ダイアログを表示しない
       * formのresetを呼んだ後のnextTickで遷移してもchangedがtrueになるのを待てないのでその代替手段
       */
        canLeave: false,
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.setRefWatch()
      })
    },
    // フォームが更新されたら監視も更新する
    updated() {
      this.setRefWatch()
    },
    async beforeRouteLeave(to, from, next) {
      if (this.canLeave) {
        next()
        return
      }
      const flags = this.$refs[formRef]?.$refs.observer?.flags
      const isChanged = flags?.changed
      if (!isChanged) {
        next()
        return
      }
      const allowLeave = await this.confirm()
      if (!allowLeave) {
        next(false)
        return
      }
      next()
    },
    async beforeRouteUpdate(to, from, next) {
      if (this.canLeave) {
        next()
        return
      }
      const flags = this.$refs[formRef]?.$refs.observer?.flags
      const isChanged = flags?.changed
      if (!isChanged) {
        next()
        return
      }
      const allowLeave = await this.confirm()
      if (!allowLeave) {
        next(false)
        return
      }
      next()
    },
    methods: {
      setRefWatch() {
        this.$watch(
          () => {
            return this.$refs[formRef]?.$refs.observer?.flags.changed || false
          },
          (val) => {
            const changed = val
            this.canLeave = !changed
          }
        )
      },
      confirm() {
        return this.$bvModal.msgBoxConfirm('入力内容が保存されておりませんが、画面から離れてもよろしいでしょうか？', {
          okTitle: '離れる',
          cancelTitle: '入力に戻る',
          centered: true,
        })
      }
    },
  }
}
